import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssFilterPage extends ComponentBase {
    protected opsOptions: Array<string> = [''];
    protected typeOptions: Array<string> = ['search', 'filter'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.getOptions();
    }

    ////****************** Example 1 ********************************************////
    protected ex1OpenOnly: boolean = true;
    protected ex1ClosedOnly: boolean = true;

    ////****************** Example 2 ********************************************////
    protected ex2Label: string | null = 'First Name';
    protected ex2Ops: string | null = this.opsOptions[0];
    protected ex2Type: string | null = this.typeOptions[0];
    protected ex2Type2: string | null = this.typeOptions[1];
    protected ex2Visible: boolean = true;
    protected ex2Removable: boolean = false;

    ////****************** Functions ************************************************////
    protected async getOptions(): Promise<void> {
        const uiJson = await fetch('/locales/en/ui.json').then(response => response.json());

        if(uiJson.filters.ops) {
            this.opsOptions = Object.keys(uiJson.filters.ops).map(objectKey => uiJson.filters.ops[objectKey]);
        }
    }
}
